export function isSandbox() {
  const location = window.location.pathname;
  return location.split("/").includes("sandbox");
}
